<template>
  <section class="ren-decoration-cp ren-decoration-cp-scenic-ticket-media">
    <img v-if="imageUrl" :src="imageUrl" alt="" class="ren-decoration-cp-scenic-ticket-media__img" />
    <div v-else class="ren-decoration-cp-scenic-ticket-media__placeholder">
      <i>票</i>
      <span>{{ title }}</span>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { stringValue } from '../../../previews/preview-helpers'
import { widgetMediaUrl } from '../../media'
import type { WidgetPreviewProps } from '../../types'

const props = defineProps<WidgetPreviewProps>()
const title = computed(() => stringValue(props.component.props?.title, '票种主图'))
const imageUrl = computed(() => widgetMediaUrl(props.component.props?.imageUrl))
</script>

<style scoped>
.ren-decoration-cp-scenic-ticket-media {
  width: 100%;
}
.ren-decoration-cp-scenic-ticket-media__img {
  display: block;
  width: 100%;
  aspect-ratio: 2 / 1;
  object-fit: cover;
}
.ren-decoration-cp-scenic-ticket-media__placeholder {
  display: grid;
  place-content: center;
  gap: 6px;
  width: 100%;
  aspect-ratio: 2 / 1;
  color: #fff;
  background: linear-gradient(135deg, var(--ren-theme-primary), var(--ren-theme-accent));
}
.ren-decoration-cp-scenic-ticket-media__placeholder i {
  font-style: normal;
  font-size: 28px;
  opacity: 0.9;
}
.ren-decoration-cp-scenic-ticket-media__placeholder span {
  font-size: 12px;
  opacity: 0.9;
}
</style>
